import * as React from 'react';

export const ShowLoaderAfterBookingContext = React.createContext<boolean>(false);
